import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";
import UserInfo from "./UserInfo";
import Spinner from "react-spinner-material";
import { useHistory } from "react-router-dom";
import {
  getTestLogs,
  submitTestResult,
  runTestCases,
} from "../../redux/Actions/TestCasesActions";
import { PropTypes } from "prop-types";

export const TestPage = (props) => {
  const history = useHistory();

  const {
    getStatus,
    getTestLogs,
    runTests,
    isGettingLogs,
    testlogs,
    isSubmittingTests,
    submitResult,
    submissionStatus
  } = props;

  const items = props.location.state;
  const tid = items && items.tid;
  const appId = items && items.id;
  const type = items && items.type;
  // const stateMerchantClass = items && items.merchantClass
  const stateMerchantClass =
    (items && items.merchantClass) || props.merchantClass || localStorage.getItem("merchant_class");


  const res = (str) => {
    let newStr = str && str.split("_").join(" ");
    return newStr;
  };

  // useEffect(() => {
  //   if (!stateMerchantClass && !appId) {
  //     // Redirect to applications page to get proper state
  //     history.push('/dashboard');
  //   }
  // }, [stateMerchantClass, appId, history]);

  useEffect(() => {
    getStatus();
    const payload = tid;
    // const merchant_class = localStorage.getItem("merchant_class")
    console.log(stateMerchantClass)
    getTestLogs(payload, stateMerchantClass);
  },
  // eslint-disable-next-line
  [getStatus, tid, getTestLogs, stateMerchantClass]);

  useEffect(() => {
    setInterval(function () {
      if (document.querySelector("#test-timer")) {
        // const merchant_class = localStorage.getItem("merchant_class")
        runTests(tid, stateMerchantClass);
      } else {
        clearInterval();
      }

    }, 10000);
    // eslint-disable-next-line
  }, [tid, stateMerchantClass]);

  const [state, setState] = useState({
    showTests: true,
    showLogs: false,
    singleTestIndex: 0,
    singleTestName: "",
    index: 1,
  });

  const showTests = (index) => {
    setState({
      showTests: (state.showTests = !state.showTests),
      index: index,
    });
  };

  const showLogs = (name, id) => {
    setState({
      showLogs: (state.showLogs = !state.showLogs),
      singleTestName: name,
      index: id,
    });
  };

  function isObject(value) {
    return value && typeof value === "object" && value.constructor === Object;
  }

  const logs = testlogs && testlogs.filter((item) => item.type)
  // const filterlogs =
  //   logs &&
  //   logs.filter(
  //     (item) =>
  //       item.transactions &&
  //       item.transactions.RESPONSE_CODE &&
  //       item.transactions.RESPONSE_CODE === "00"
  //   );
  const allPassedTests = logs && logs.filter(
    (item) =>
      item.transactions &&
      item.transactions.RESPONSE_CODE &&
      item.transactions.RESPONSE_CODE === "00"
  );

  // For merchant class 003, ensure compulsory tests pass first
  const filterlogs = (() => {
    if (stateMerchantClass === "003" && allPassedTests) {
      const requiredTestTypes = ["CASH_WITHDRAWAL", "REVERSAL"]; // Replace with actual required types
      const passedRequiredTests = allPassedTests.filter(item => 
        requiredTestTypes.includes(item.type)
      );
      
      // If not all 2 compulsory tests have passed, return reduced count
      if (passedRequiredTests.length < 2) {
        return { length: 1 }; // Always less than required 2
      }
    }
    return allPassedTests;
  })();
  const filterlogsIds = logs && logs.map((item) => item.id);

  const submitTestResult = () => {
    const payload = {
      types: filterlogsIds,
      application_id: appId && appId.toString(),
      type: type,
    };
    submitResult(payload);
  };

  const getRequiredTestCount = () => {
    // const merchantClass = localStorage.getItem("merchant_class");
    return stateMerchantClass === "003" ? 2 : 8;
  };

  useEffect(() => {
    if (submissionStatus) {
      history.push({
        pathname: "/success",
        state: {
          id: appId,
          type: type,
        },
      });
    }
  },
  // eslint-disable-next-line
  [submissionStatus, history, appId, type]);

  return (
    <div className="container2">
      <UserNav />
      <Sidebar />

      <div className="container-body2">
        <UserInfo />
      </div>

      <div className="container-body5">
        <div className="testcase-header">
          <h2 id="test-timer">This is your Test Environment</h2>
          <h4>
            We highly recommend you take all the tests required in this section
          </h4>
        </div>

        {isGettingLogs ? (
          <div className="center-spinner">
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        ) : (
            <div className="testcase-total">
              {logs && logs.length === 0 ? (
                <div className="empty-test">No test steps</div>
              ) : (
                  <div className="testcase-total">
                    <div className="testcase-grid">
                      {logs &&
                        logs.map((item) => (
                          <div
                            className={
                              item.transactions &&
                                Object.keys(item.transactions).length > 0
                                ? "testcase-holder"
                                : "testcase-holder2"
                            }
                            key={item.id}
                          >
                            <div className="testcase-top">
                              <div className="testcase-top-top">
                                <p>
                                  {res(item.type) || "--"}{" "}
                                  {item.transactions &&
                                    Object.keys(item.transactions).length > 0 && (
                                      <h2
                                        className={
                                          item.transactions &&
                                            item.transactions.RESPONSE_CODE === "00"
                                            ? "passed-test"
                                            : "failed-test"
                                        }
                                      >
                                        {item.transactions &&
                                          item.transactions.RESPONSE_CODE === "00"
                                          ? "Passed - "
                                          : "Failed"}
                                      </h2>
                                    )}
                                </p>
                                <div className="testcase-top-top-right">
                                  <button
                                    className="view-logs"
                                    onClick={() => showTests(item.id)}
                                  >
                                    {state.showTests && state.index === item.id
                                      ? "hide test steps"
                                      : "show test steps"}
                                  </button>
                              &nbsp; &nbsp;
                              <button
                                    disabled={
                                      item.transactions &&
                                      Object.keys(item.transactions).length === 0
                                    }
                                    className="view-logs"
                                    onClick={() => showLogs(item.type, item.id)}
                                  >
                                    {state.showLogs &&
                                      state.singleTestName === item.type &&
                                      state.index === item.id
                                      ? "hide logs"
                                      : "show logs"}
                                  </button>
                                </div>
                              </div>

                              {state.showLogs &&
                                state.singleTestName === item.type &&
                                state.index === item.id && (
                                  <div className="logs-div">
                                    {item.transactions &&
                                      Object.entries(item.transactions).length ===
                                      0 ? (
                                        <div className="logs-div-item">
                                          No logs for this test
                                        </div>
                                      ) : (
                                        item.transactions &&
                                        Object.entries(item.transactions).map(
                                          (key, value) => (
                                            <div
                                              className="logs-div-item"
                                              key={value}
                                            >
                                              <span>{res(key[0])}:</span>{" "}
                                              {isObject(key[1]) === true ? (
                                                <div>
                                                  {key[1] &&
                                                    Object.entries(key[1]).map(
                                                      (key, value) => (
                                                        <div
                                                          className="logs-div-item-object"
                                                          key={value}
                                                        >
                                                          <span>{res(key[0])}</span>
                                                          <span>{key[1] || "-"}</span>
                                                        </div>
                                                      )
                                                    )}
                                                </div>
                                              ) : (
                                                  <span>{key[1]}</span>
                                                )}
                                            </div>
                                          )
                                        )
                                      )}
                                  </div>
                                )}
                            </div>

                            {state.showTests && state.index === item.id && (
                              <>
                                <div className="testcase-bottom">
                                  {item.steps &&
                                    item.steps.map((test, index) => (
                                      <div
                                        className="testcase-bottom-item"
                                        key={index}
                                      >
                                        <div className="testcase-bottom-item-top">
                                          <p>{res(test) || "--"}</p>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </>
                            )}
                          </div>
                        ))}
                    </div>

                    <div className="testcase-btn">
                      <button
                        disabled={
                          isSubmittingTests ||
                          (filterlogs && filterlogs.length !== getRequiredTestCount())
                            // ( localStorage.getItem("merchant_class") === "003" ? 4 : 8))
                        }
                        onClick={() => submitTestResult()}
                      >
                        SUBMIT RESULT
                  </button>
                    </div>
                  </div>
                )}
            </div>
          )}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getStatus: () => dispatch(getUserStatus()),
  getTestLogs: (payload, merchant_class) => dispatch(getTestLogs(payload, merchant_class)),
  submitResult: (payload) => dispatch(submitTestResult(payload)),
  runTests: (tid, merchant_class) => dispatch(runTestCases(tid, merchant_class)),
});

const mapStateToProps = (state) => {
  return {
    isGetting: state.docs.isGetting,
    status: state.docs.status,
    getStatusSuccess: state.docs.getStatusSuccess,
    isGettingLogs: state.testcases.isGettingTestLogs,
    testLogsSuccess: state.testcases.testLogsSuccess,
    testlogs: state.testcases.testLogs || state.testcases.testResults,
    isRunningTests: state.testcases.isRunningTests,
    testSuccess: state.testcases.testSuccess,
    testResults: state.testcases.testResults,
    isSubmittingTests: state.testcases.isSubmittingTests,
    submissionStatus: state.testcases.submissionStatus,
    tests: state.testcases.tests,
    merchantClass: state.docs && state.docs.merchantClass,
  };
};

TestPage.propTypes = {
  getStatus: PropTypes.func,
  getTestLogs: PropTypes.func,
  isGettingLogs: PropTypes.any,
  isSubmittingTests: PropTypes.any,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.any,
      tid: PropTypes.any,
      type: PropTypes.any
    })
  }),
  runTests: PropTypes.func,
  merchantClass: PropTypes.string,
  submissionStatus: PropTypes.any,
  submitResult: PropTypes.func,
  testlogs: PropTypes.shape({
    filter: PropTypes.func
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(TestPage);
